export default "__VITE_ASSET__fM5Joymy__"